<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16V1QuA/images/e9781439627877_cover.jpg?1684255542145" alt="This image is the cover for the book Pontiac, Michigan, Postcard History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pontiac, Michigan, Postcard History
      </h1>
      <p class="bookDescription body article font2">
        <p>"I am sending you this so you won't forget Pontiac." This is the sentiment inscribed on one of the postcards included in this collection. Pontiac, Michigan: A Postcard Album brings to life the history of this uniquely American city. The postcard has always been a very popular means of communication, and now as a historical document, it offers us a fascinating insight into the times and places of the past. Like many cities, Pontiac has passed through many phases, from agricultural center to auto manufacturer�through good times and bad. These postcards capture the people and places of Pontiac, and remind us of the courageous people who built this country.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gottfried Brieger
      </h2>
      
      <p class="authorDescription body article">Gottfried Brieger has collected nearly 200 images to tell the story of Pontiac, from the early days to the present-bringing the past to life.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5bfb6abe